/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiPersonServiceAreasRetrieveParams } from './model/apiPersonServiceAreasRetrieveParams';
import type { PersonServiceAreas } from './model/personServiceAreas';

/**
 * Returns service area metadata for each active service type.

Response is a dict mapping service type slugs to an object containing the signed
static map URL for hosting services and the underlying geometry (polygon coordinates
or radius in meters) for traveling services.
 */
export const apiPersonServiceAreasRetrieve = (
  opk: string,
  params?: ApiPersonServiceAreasRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PersonServiceAreas>({
    url: `/api/v7/people/${opk}/service-areas/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiPersonServiceAreasRetrieveQueryKey = (
  opk?: string,
  params?: ApiPersonServiceAreasRetrieveParams
) => {
  return [`/api/v7/people/${opk}/service-areas/`, ...(params ? [params] : [])] as const;
};

export const getApiPersonServiceAreasRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonServiceAreasRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiPersonServiceAreasRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>> = ({
    signal,
  }) => apiPersonServiceAreasRetrieve(opk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiPersonServiceAreasRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>
>;
export type ApiPersonServiceAreasRetrieveQueryError = ErrorType<unknown>;

export function useApiPersonServiceAreasRetrieve<
  TData = Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonServiceAreasRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonServiceAreasRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiPersonServiceAreasRetrieveQueryOptions(opk, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
